import {ShapeCommand} from '../commands.template';
import {getActivityMinWH} from '../../diagram-render/styles/styles.util';
declare let mxUtils: any;

export class ActivityAddAttributeCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  mxKey: number;

  executionDelta: number;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public execute() {
    super.execute();
    this.mxKey = this.object.mxKey || this.getMxKey(this.object.activityMxKey);
    const action = {
      addAttribute: {
        activityMxKey: Number(this.object.activityMxKey),
        mxKey: this.mxKey,
        text: this.object.text || 'Attribute'
      }
    };

    this.executionDelta = this.applyGraphChanges(true);
    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.activityMxKey);
  }

  public reverse() {
    super.reverse();
    const action = {
      deleteAttribute: {
        mxKey: this.mxKey,
        activityMxKey: Number(this.object.activityMxKey)
      }
    };

    this.applyGraphChanges(false, this.executionDelta);
    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.activityMxKey);
  }

  private applyGraphChanges(add, previousDelta = null) {
    const dy = add ? 26 : -26;
    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = graph.model.getCell(this.object.activityMxKey);
    const geo = cell.geometry.clone();
    const {minHeight} = getActivityMinWH(
      cell.getJson(),
      this.services.diagramTypeConfigService.currentType()
    );

    graph.getModel().beginUpdate();
    cell.skipUndo = true;
    const newMinHeight = minHeight + dy;
    const deltaY = newMinHeight > geo.height ? newMinHeight - geo.height : 0;
    const actualDeltaY = previousDelta ?? deltaY;

    this.translateCellsConnectionPointsForAttribute(cell, deltaY);
    graph.getModel().setStyle(cell, mxUtils.setStyle(cell.style, 'minHeight', newMinHeight));
    geo.height += actualDeltaY;
    graph.getModel().setGeometry(cell, geo);
    this.services.flHelper.translateConnectedEdges(
      [cell],
      {dx: 0, dy: 0},
      {dx: 0, dy: actualDeltaY}
    );
    graph.getModel().endUpdate();

    return -deltaY;
  }

  private getMxKey(activityMxKey) {
    const activity = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(activityMxKey);
    });

    if (!activity.attributes) {
      activity.attributes = [];
    }

    // generate new mxKey
    let mxKey = 0;

    activity.attributes.forEach(att => {
      if (att.mxKey > mxKey) {
        mxKey = att.mxKey;
      }
    });

    return mxKey + 1;
  }

  private redrawActivity(activityMxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(activityMxKey))
      .comp.instance.setupFromJson();
  }

  private translateCellsConnectionPointsForAttribute(cell, dy) {
    const graph = this.services.editorRegistrySvc.getGraph();
    const model = graph.getModel();

    if (cell.edges) {
      cell.edges.forEach(edge => {
        if (
          edge.source &&
          Number(edge.source.id) === Number(cell.id) &&
          isInRange(graph.getCellStyle(edge).exitY)
        ) {
          setNewY(edge, true);
        } else if (
          edge.target &&
          Number(edge.target.id) === Number(cell.id) &&
          isInRange(graph.getCellStyle(edge).entryY)
        ) {
          setNewY(edge, false);
        }
      });
    }

    function setNewY(edge, isSource) {
      const height = cell.geometry.height;
      const oldY = isSource ? graph.getCellStyle(edge).exitY : graph.getCellStyle(edge).entryY;
      let newY = oldY - (1 - height / (height + dy)) * oldY;

      if (newY < 0.01) {
        newY = 0.01;
      }

      if (newY > 0.99) {
        newY = 0.99;
      }

      if (isSource) {
        model.setStyle(edge, mxUtils.setStyle(edge.style, 'exitY', newY));
      } else {
        model.setStyle(edge, mxUtils.setStyle(edge.style, 'entryY', newY));
      }
    }

    function isInRange(num: number) {
      return num >= 0.01 && num <= 0.99;
    }
  }
}
